const MappedLeitnerBoxWithDays: Record<string, string> = {
    BOX_1: 'Day 1',
    BOX_2: 'Day 2',
    BOX_3: 'Day 4',
    BOX_4: 'Day 7',
    BOX_5: 'Perfect',
};

export default MappedLeitnerBoxWithDays;
